const GENDERS = {
    MALE: 1,
    FEMALE: 2,
};

export { GENDERS };
export default { GENDERS };



// WEBPACK FOOTER //
// ./src/constants/profile.js